import produce from 'immer'

import * as ACTs from './actions'

export const Types = {}

Object.values(ACTs).forEach((fn) => {
  const type = fn().type

  Types[type.split('/').pop()] = type
})

const INITIAL_STATE = {
  loadings: {
    identify: false,
    register: false
  },
  errors: {
    identify: null,
    register: null
  },
  consumer: null
}

export default function prizeReducers(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.IDENTIFY_CONSUMER: {
        draft.loadings.identify = true
        draft.errors.identify = null
        break
      }
      case Types.RESOLVE_IDENTIFICATION: {
        draft.loadings.identify = false
        draft.consumer = action.payload?.consumer || null
        draft.errors.identify = action.payload?.error || null
        break
      }
      case Types.RESET_IDENTIFICATION: {
        return INITIAL_STATE
      }
      case Types.REGISTER_CONSUMER: {
        draft.loadings.register = true
        draft.errors.register = null
        break
      }
      case Types.RESOLVE_REGISTRATION: {
        draft.loadings.register = false
        draft.errors.register = action.payload?.error || null

        if (action.payload?.consumer) {
          draft.consumer = action.payload.consumer
        }

        break
      }
      default:
    }
  })
}
